import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import { CtbCcService } from '../../../catalogo/ctb-cc/ctb-cc.service';
import { jsPDF } from "jspdf";
import Swal from 'sweetalert2';
@Component({
  selector: 'app-balanza-comprobacion-cc',
  templateUrl: './balanza-comprobacion-cc.component.html',
  styleUrls: ['./balanza-comprobacion-cc.component.css']
})
export class BalanzaComprobacionCcComponent implements OnInit {

  public mes: number;
  public ano: number;
  public cc_id: number;
  public anos: any[] = [];
  public meses: any[] = [
    { numero: 1, nombre: 'enero' },
    { numero: 2, nombre: 'febrero' },
    { numero: 3, nombre: 'marzo' },
    { numero: 4, nombre: 'abril' },
    { numero: 5, nombre: 'mayo' },
    { numero: 6, nombre: 'junio' },
    { numero: 7, nombre: 'julio' },
    { numero: 8, nombre: 'agosto' },
    { numero: 9, nombre: 'septiembre' },
    { numero: 10, nombre: 'octubre' },
    { numero: 11, nombre: 'noviembre' },
    { numero: 12, nombre: 'diciembre' }];
  public reporte : any = { contenido: []};
  public select_cc: any[] = [];

  constructor(private ctbCcService: CtbCcService,private loginService: LoginService) { }

  ngOnInit(): void {
    this.cc_id = 0;
    this.mes = 1;
    this.cargarSelectCc();
    this.cargarAnos();
    this.cargarReporte(false);

  }
  cargarSelectCc(){
    
    this.ctbCcService.selectByMesAnioEmp(this.mes,this.ano,this.loginService.empresa).subscribe(
      response =>{
        this.cc_id = 0;
        this.select_cc = response.contenido;
      }
    );
  }
  cargarAnos() {
    const ejercicios = JSON.parse(String(localStorage.getItem('ejercicios')));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    this.ano = this.loginService.ejercicio;
    // this.cargarReporte();
  }
  async downloadPDF() {
    this.mostrarMensajeCarga('');
    const titulo_pdf =  'BC' + this.mes + '-' + this.ano;
    let pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'px',
      format: 'letter',
      compress: false,
    })
    var source = document.getElementById("itemImprimir");
    await pdf.html(
      source, {
      // Adjust your margins here (left, top, right ,bottom)
      margin: [30, 30, 30, 30]
    });
    pdf.save(titulo_pdf + '.pdf');
    this.cerrarMensajeCarga();
  }
  cargarReporte(actualizar_select: boolean){
    this.ctbCcService.getReporteBalanzaComprobacionCc(this.mes,this.ano,this.cc_id,this.loginService.empresa).subscribe(
      response =>{
        this.reporte = response.contenido;
        if(actualizar_select){
        this.cargarSelectCc();
              }      }
    );
  }
  
  exportAsXLSX() {
      this.ctbCcService.getRepBalCompXlsx(this.mes,this.ano,this.cc_id,this.loginService.empresa).subscribe(
        response => {
          console.log(response);
          const a = document.createElement('a');
          const titulo_pdf =  'BC' + this.mes + '-' + this.ano;
          a.href = URL.createObjectURL(response);
          a.download = titulo_pdf + '.xls';
          document.body.appendChild(a);
          a.click();
        }
      );
  }
  mostrarMensajeCarga(mensaje: string) {
    const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
    const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
    Swal.fire({
      html: `
      <div style="text-align: center">
        <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
        <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
      </div>`,
      toast: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }
  cerrarMensajeCarga() {
    Swal.close();
  }
}
